import BaseComponent from "../../../../baseComponent.js";
import styles from "./overview.scss";

export default class Overview extends BaseComponent {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.description}>
          {this.props.dataset.description}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/data-bank/dataset-detail/content/overview/overview.jsx